//
// Mock Canvas / Context2D calls
//
/* istanbul ignore next */
const canvasPlugin = () => {
  if (!global || !global.window || !global.window.HTMLCanvasElement) {
    throw new Error(
      'HTMLCanvasElement not found. Did you create the window object? Usually this is done with the jsdom library.'
    )
  }

  window.HTMLCanvasElement.prototype.getContext = function () {
    return {
      fillRect: function () {},
      clearRect: function () {},
      getImageData: function (x, y, w, h) {
        return {
          data: new Array(w * h * 4),
        }
      },
      putImageData: function () {},
      createImageData: function () {
        return []
      },
      setTransform: function () {},
      drawImage: function () {},
      save: function () {},
      fillText: function () {},
      restore: function () {},
      beginPath: function () {},
      moveTo: function () {},
      lineTo: function () {},
      closePath: function () {},
      stroke: function () {},
      translate: function () {},
      scale: function () {},
      rotate: function () {},
      arc: function () {},
      fill: function () {},
      measureText: function () {
        return { width: 0 }
      },
      transform: function () {},
      rect: function () {},
      clip: function () {},
    }
  }

  window.HTMLCanvasElement.prototype.toDataURL = function () {
    return ''
  }
}

export default canvasPlugin
